import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { getPostCounts } from "../../../redux/posts/action";
import AllTabOrderRequests from "./OrderRequests/AllTabOrderRequests";
import AllActiveOrders from "./ActiveOrders/AllActiveOrders";
import AllCompletedRecivedOrder from "./CompletedRecivedOrder/AllCompletedRecivedOrder";
import { useRouteBaseStateContext } from "../../../Context/RouteBaseStateContext";
import MineCancelledBXPListingSecond from "../MyOrders/MyOrders/CancelledOrder/AllCancelledOrder/MineCancelledBXPListingSecond";
import CanceledRecivedOrdersAllTabs from "./CanceledRecivedOrders/CanceledRecivedOrdersAllTabs";

export default function DashboardReceivedOrders() {
  const { urlstate, setReceivedOrderroute, resetAllFields } = useRouteBaseStateContext();

  const path = "Assets/scss/postproject.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  
  const dispatch = useDispatch();
  const postcounts = useSelector(({ posts: { postcounts } }) => postcounts);
  const [activeTab, setActiveTab] = useState("Orderequests");

  useEffect(() => {
    dispatch(getPostCounts(7));
  }, [dispatch]);

  function sumOrders(orderType) {
    const orders = postcounts[orderType];
    if (!orders) {
      console.error(`Order type ${orderType} not found`);
      return 0;
    }
    return Object.values(orders).reduce(
      (total, num) => total + parseInt(num, 10),
      0,
    );
  }

  const postedOrdersCount = sumOrders("order_request");
  const purchasedOrdersCount = sumOrders("active_orders");
  const completedOrdersCount = sumOrders("completed_orders");
  const canceledOrdersCount = sumOrders("cancelled_orders");

  const handleTabClick = (tab) => {
    resetAllFields();
    setActiveTab(tab);
    setReceivedOrderroute(tab);
  };

  useEffect(() => {
    if (urlstate?.receivedorderroute) {
      setActiveTab(urlstate?.receivedorderroute || "Orderequests");
    } else {
      setActiveTab("Orderequests");
    }
  }, [urlstate, urlstate?.receivedorderroute]);

  return (
    <div className="order-section">
      <div className="tab-sec">
        <div className="order-first">
          <h2>Received Orders</h2>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a
                
                data-toggle="tab"
                className={`nav-link ${activeTab == "Orderequests" ? "active" : ""}`}
                onClick={() => handleTabClick("Orderequests")}
              >
                Order requests ({postedOrdersCount})
              </a>
            </li>
            <li className="nav-item">
              <a
                
                data-toggle="tab"
                className={`nav-link ${activeTab == "Activeorders" ? "active" : ""}`}
                onClick={() => handleTabClick("Activeorders")}
              >
                Active orders ({purchasedOrdersCount})
              </a>
            </li>
            <li className="nav-item">
              <a
                
                data-toggle="tab"
                className={`nav-link ${activeTab == "Completed" ? "active" : ""}`}
                onClick={() => handleTabClick("Completed")}
              >
                Completed ({completedOrdersCount})
              </a>
            </li>
             <li className="nav-item">
              <a
                
                data-toggle="tab"
                className={`nav-link ${activeTab == "Canceled" ? "active" : ""}`}
                onClick={() => handleTabClick("Canceled")}
              >
                Canceled ({canceledOrdersCount})
              </a>
            </li>
          </ul>
        </div>
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab == "Orderequests" ? "active" : ""}`}
            id="Orderequests"
          >
            <AllTabOrderRequests postcounts={postcounts?.order_request}  />
          </div>
          <div
            className={`tab-pane ${activeTab == "Activeorders" ? "active" : ""}`}
            id="Activeorders"
          >
            <AllActiveOrders postcounts={postcounts?.active_orders} />
          </div>
          <div
            className={`tab-pane ${activeTab == "Completed" ? "active" : ""}`}
            id="Completed"
          >
            <AllCompletedRecivedOrder
              postcounts={postcounts?.completed_orders} 
            />
          </div>
           <div
            className={`tab-pane ${activeTab == "Canceled" ? "active" : ""}`}
            id="Canceled"
          >
            <CanceledRecivedOrdersAllTabs postcounts={postcounts?.cancelled_orders} />
            
          </div>
        </div>
      </div>
    </div>
  );
}
